import { API } from './interceptor'

async function unwrap(response, fallbackMessage) {
  if (response?.success === false) {
    throw new Error(response?.message || fallbackMessage)
  }
  return response?.data !== undefined ? response.data : response
}

export async function createProductIssue(venueId, body) {
  if (!venueId) throw new Error('Missing venue id')
  try {
    const response = await API.post(
      'api2',
      `product-issues/venue/${encodeURIComponent(venueId)}`,
      { body },
    )
    return unwrap(response, 'Could not submit the product issue.')
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        'Could not submit the product issue.',
    )
  }
}

export async function listVenueProductIssues(venueId, query = {}) {
  if (!venueId) throw new Error('Missing venue id')
  const params = new URLSearchParams()
  Object.entries(query).forEach(([key, value]) => {
    if (value != null && value !== '') params.set(key, String(value))
  })
  const qs = params.toString()
  try {
    const path = `product-issues/venue/${encodeURIComponent(venueId)}${
      qs ? `?${qs}` : ''
    }`
    const response = await API.get('api2', path)
    return unwrap(response, 'Could not load product issues.')
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        'Could not load product issues.',
    )
  }
}

export async function updateVenueProductIssueStatus(venueId, issueId, body) {
  if (!venueId || !issueId) throw new Error('Missing venue or issue id')
  try {
    const response = await API.patch(
      'api2',
      `product-issues/venue/${encodeURIComponent(venueId)}/${encodeURIComponent(
        issueId,
      )}`,
      { body },
    )
    return unwrap(response, 'Could not update the product issue.')
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        'Could not update the product issue.',
    )
  }
}

export async function listAllProductIssues(query = {}) {
  const params = new URLSearchParams()
  Object.entries(query).forEach(([key, value]) => {
    if (value != null && value !== '') params.set(key, String(value))
  })
  const qs = params.toString()
  try {
    const path = `product-issues${qs ? `?${qs}` : ''}`
    const response = await API.get('api2', path)
    return unwrap(response, 'Could not load product issues.')
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        'Could not load product issues.',
    )
  }
}

export async function updateProductIssueStatus(issueId, body) {
  if (!issueId) throw new Error('Missing issue id')
  try {
    const response = await API.patch(
      'api2',
      `product-issues/${encodeURIComponent(issueId)}`,
      { body },
    )
    return unwrap(response, 'Could not update the product issue.')
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        'Could not update the product issue.',
    )
  }
}
